import { updateDoc } from "firebase/firestore";
import { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { getCSuitDoc, getUserDoc } from "../utils/firestoreHelpers";
import { addDaysToCurrentDate, createRandomId } from "../utils/helpers";
import { useHttpsCallable } from "react-firebase-hooks/functions";
import { fFunctions } from "../config/firebase";
import { mailType } from "../utils/constants";
import { getCallablePayload } from "../utils/callableResult";

const SendEmail = ({ data, onClose, type }) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const fns = fFunctions;
  const [sendInvitationEmail, isExecuting, funcError] = useHttpsCallable(
    fns,
    "sendInvitationEmail"
  );
  const [sendWelcomeInvitationEmail, welcomeExecuting, welcomeFuncError] =
    useHttpsCallable(fns, "sendWelcomeTemplate");

  const onSend = async () => {
    setErrorMessage("");
    if (type === mailType.INVITATION) {
      setLoading(true);
      try {
        const randomId = createRandomId(6, true);
        const expiryTime = addDaysToCurrentDate(2);
        const doc = getCSuitDoc(data.id);
        const raw = await sendInvitationEmail({
          email: data.email,
          name: data.first_name + " " + data.last_name,
          verification_code: randomId,
        });
        const res = getCallablePayload(raw);
        if (res?.error) {
          setErrorMessage(
            typeof res.error === "string" ? res.error : String(res.error)
          );
          return;
        }
        const newFields = {
          status: "Sent Email",
          expiry_time: expiryTime,
          code: randomId,
        };
        await updateDoc(doc, newFields);
        onClose();
      } catch (e) {
        setErrorMessage(e?.message || String(e));
      } finally {
        setLoading(false);
      }
    } else if (type === mailType.WELCOME) {
      setLoading(true);
      try {
        const doc = getUserDoc(data.id);
        const raw = await sendWelcomeInvitationEmail({
          email: data.email,
          name: data.first_name + " " + data.last_name,
          password: data.password,
        });
        const res = getCallablePayload(raw);
        if (res?.error) {
          setErrorMessage(
            typeof res.error === "string" ? res.error : String(res.error)
          );
          return;
        }
        const newFields = {
          status: "Sent Email",
        };
        await updateDoc(doc, newFields);
        onClose();
      } catch (e) {
        setErrorMessage(e?.message || String(e));
      } finally {
        setLoading(false);
      }
    }
  };

  if (!data) return null;
  return (
    <Modal show={true} onHide={() => {}}>
      <Modal.Header>
        <Modal.Title>
          Are you sure you want to invite {data.first_name} {data.last_name}?
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <table className="table table-light">
          <thead>
            <tr>
              <td>First Name</td>
              <th>{data.first_name}</th>
            </tr>
            <tr>
              <td>Last Name</td>
              <th>{data.last_name}</th>
            </tr>
            <tr>
              <td>Email</td>
              <th>{data.email}</th>
            </tr>
            <tr>
              <td>Mobile</td>
              <th>
                {data.dial_code} {data.mobile_number}
              </th>
            </tr>
            <tr>
              <td>Designation</td>
              <th>{data.designation}</th>
            </tr>
            <tr>
              <td>Company</td>
              <th>{data.company}</th>
            </tr>
            <tr>
              <td>LinkedIn Link</td>
              <th>{data.linkedIn || "N/A"}</th>
            </tr>
          </thead>
        </table>
        <p className="text-center small text-danger">
          {funcError?.message ||
            welcomeFuncError?.message ||
            errorMessage}
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Close
        </Button>
        <Button variant="primary" onClick={onSend} disabled={loading}>
          {loading ? (
            <>
              <span
                class="spinner-grow spinner-grow-sm me-2"
                role="status"
                aria-hidden="true"
              ></span>
              Loading...
            </>
          ) : (
            "Send"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SendEmail;
